import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: (failureCount, error) => {
                const status = (error as { response?: { status?: number } })?.response?.status;
                if (status && status >= 400 && status < 500) return false;
                return failureCount < 2;
            },
            refetchOnWindowFocus: false,
            staleTime: 30_000,
        },
        mutations: {
            retry: false,
        },
    },
});
